'use client'

import { SwapPage } from '@/containers/Swap'

export default function Page() {
  return <SwapPage />
}
